var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-excel',{staticClass:"export_btn",attrs:{"type":"csv","name":`Report_${_vm.volunteer.code}-${_vm.volunteer.name} (${_vm.$route.query.month}/${_vm.$route.query.year}).xls`,"fields":_vm.custom_fields,"fetch":_vm.getData,"footer":[
    `${_vm.volunteer.code}-${_vm.volunteer.name}`,
    `${_vm.$route.query.month}/${_vm.$route.query.year}`,
  ]}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v("mdi-chevron-right-circle-outline")]),_vm._v("Export ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }